<div class="card">
    <div class="card_body">
        <p class="row_text fz_xs color_text_gray">{{title}}</p>
        <div class="skeleton_container" *ngIf="isLoading" style="width: 80px"><app-skeleton height="20"></app-skeleton>
        </div>
        <p *ngIf="!isLoading" class="row_text fz_l fw_500">{{currentValue > 0 ? dollar : ''}}{{currentValue}}</p>
        <div class="skeleton_container" *ngIf="isLoading" style="width: 130px"><app-skeleton height="15.5"></app-skeleton>
        </div>
        <div *ngIf="!isLoading" class="row row_text fz_xs">
            <p class="color_text_gray">за 7 дней</p>
            <p class="row dynamics"
                [ngClass]="{'color_red': dynamics === 'negative', 'color_green': dynamics === 'positive' || dynamics === 'neutral'}">
                <span *ngIf="dynamics === 'positive'" class="material-symbols-outlined">
                    trending_up
                </span>
                <span *ngIf="dynamics === 'negative'" class="material-symbols-outlined">
                    trending_down
                </span>
                {{displayPercent}}%
            </p>
        </div>
    </div>
</div>